
<div class="video-list-container">

  <div class="video-cards-grid">
    <!-- Iterate over the videos array to display each video as a card -->
    @for (video of videos(); track video; let i = $index) {
      <mat-card appearance="outlined" class="video-card mat-elevation-z4">
        <mat-card-header >
          <mat-card-title  (click)="onSelectVideo(video)" [style.background-color]="colors[i % colors.length]">{{ video.title }}</mat-card-title>
          @if (video.hasPermission) {
            <button
              mat-flat-button
              color="white"
              (click)="onSelectVideo(video)"
              class="view-button">
              <mat-icon>play_arrow</mat-icon> Play Video
            </button>
          }
          @if (!video.hasPermission) {
            <mat-expansion-panel class="desc-panel">
              <mat-expansion-panel-header>
                <mat-panel-title> Details... </mat-panel-title>
              </mat-expansion-panel-header>
              <p>{{ video.description }}</p>
              <a routerLink="/snippets"  title="Training Snippets">Training Snippets</a>
            </mat-expansion-panel>
          }
        </mat-card-header>
        <mat-card-actions class="card-actions right-aligned-btn">
          @if (!isLoggedIn()) {
            <button
              mat-flat-button
              color="white"
              routerLink="/login"
              class="view-button">
              <mat-icon>lock</mat-icon> Must Login To Purchase...
            </button>
          }
          @if (isLoggedIn() && !video.hasPermission) {
            <button
              color="white"
              (click)="onPurchase(video.priceID)"
              class="view-button">
              <b>Purchase ${{video.amount}}.00</b>
            </button>
          }
        </mat-card-actions>
      </mat-card>
    }
  </div>
</div>
